module.exports = __webpack_public_path__ + "static/media/yewu-cj1.1f56c27a.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageIntelligentDataSecurityGateway/yewu-cj1.png
// module id = 238
// module chunks = 0